export default {
    Get: {
        LIST_OF_CHARGES: 'getListOfCharges',
        LIST_OF_PUBLIC_UTILITIES: 'getListOfPublicUtilities'
    },
    Set: {
        LIST_OF_ROOMS: 'setListOfRooms',
        CHARGE_ELEMENT: 'setChargeElements',
        UPDATE_NEW_PUBLIC_UTILITY: 'updateNewPublicUtility',
    }
};